import $ from "jquery";

$(document).ready(function () {
    if ($(".bizform-wrapper[id^='form-TestForm']").length) {
        handleFeedbackForm();
        $(document).on("FormSectionLoaded", function () {
            handleFeedbackForm();
        });

        //calling movingLabels for active states
        setupMovingLabels();
    }
});

function handleFeedbackForm() {
    $("form").attr("autocomplete", "off");

    //and charCountText area for our character counter value
    $("textarea.form-control").addClass("charCountTextArea");
    $(".charCountTextArea").parent().append("<div id='charNum'></div>");
    countChar($(".charCountTextArea").val());
    $(".charCountTextArea").on('keydown keyup input propertychange paste change', function () {
        countChar($(".charCountTextArea").val());
    });

    //input-validation-error
    $("input[type='submit']").on("click", function () {
        if ($("input.form-control").hasClass("input-validation-error")) {
            var errorMessage = '<div class="row"><div class="large-12 error-message-alert">Please correct the error(s) above</div></div>';
            $("section.two-col").append(errorMessage);
        }
    });

    $(".form-control").on("blur", function () {
        if ($(".form-control:required").length == $(".form-control.has-content:required").length) {
            $("input[type='submit']").removeAttr("disabled");
        }
    });
}

function countChar(str) {
    var normalizedStr = str.replace(/\n/g, '\r\n'); //normalize line endings for count to CRLF (\r\n) to ensure display count matches server count
    var len = normalizedStr.length;

    if (len >= 350) {
        $('#charNum').text(len + "/350");
        //toggleTextareaTyping();
    } else {
        $('#charNum').text(len + "/350");
        //console.log(len + "/350");
    }
}

//reusing this from lead-forms.js
function setupMovingLabels() {
    $("input.form-control").on("focus", function () {
        if ($(this).val() !== "") {
            $(this).parent().addClass("has-content");
        } else {
            $(this).parent().removeClass("has-content");
        }
    });

    $("input.form-control").on("input", function () {
        if ($(this).val() !== "") {
            $(this).parent().addClass("has-content");
        } else {
            $(this).parent().removeClass("has-content");
        }
    });

    $('textarea.form-control').on('input', function () {
        var $label = $(this).parent().find('label');
        if ($(this).val() != '' && $label.hasClass('select-label')) {
            $label.addClass('show-for-sr');
        }
    });

    // move labels if browser has pre-filled inputs
    $("form :input").each(function () {
        if ($(this).val() !== "")
            $(this).parent().addClass("has-content");
    });


    // sets has-content when input changes
    $(document).on("input", "form.bizform .form-control", function () {
        if ($(this).val() !== "") {
            $(this).closest(".form-field").addClass("has-content");
            $(this).addClass("form-control-used");
        } else {
            if ($(this).closest(".form-field").hasClass("has-content"))
                $(this).closest(".form-field").removeClass("has-content");
            if ($(this).hasClass("form-control-used"))
                $(this).removeClass("form-control-used");
        }

        checkRequiredFields("item: form-control, event: input");
    });

    $(document).on("FormSectionLoaded", function () {
        resetHasContent("item: document, event: FormSectionLoaded");
    });

    function checkRequiredFields(handlerName) {
        var requiredFieldCount = $("form.bizform .form-field-required").length;
        var requiredFieldsWithContent = $("form.bizform .form-field-required.has-content").length;

        //console.log({ handlerName, requiredFieldCount, requiredFieldsWithContent });

        if (requiredFieldCount > 0 && requiredFieldCount === requiredFieldsWithContent) {
            //console.log("enable submit");
            $("form.bizform input[type='submit']:disabled").removeAttr("disabled");
        } else {
            //console.log("disable submit");
            $("form.bizform input[type='submit']").attr("disabled", "disabled");
        }
    }

    function resetHasContent(handlerName) {

        $("form.bizform textarea.form-control").each(function () {
            if ($(this).val() !== "") {
                $(this).closest(".form-field").addClass("has-content");
                $(this).addClass("form-control-used");
            } else {
                if ($(this).closest(".form-field").hasClass("has-content"))
                    $(this).closest(".form-field").removeClass("has-content");
                if ($(this).hasClass("form-control-used"))
                    $(this).removeClass("form-control-used");
            }
        });

        $("form.bizform input[type=text].form-control").each(function () {
            if ($(this).val() !== "") {
                $(this).closest(".form-field").addClass("has-content");
            } else if ($(this).closest(".form-field").hasClass("has-content")) {
                $(this).closest(".form-field").removeClass("has-content");
            }
        });

        $("form.bizform input[type=radio].form-control").each(function () {
            if ($(this).is(':checked')) {
                $(this).closest(".form-field").addClass("has-content");
            }
        });


        checkRequiredFields(handlerName);
    }

}
